import React from 'react';

class About extends React.Component {
	render() {
		return (
			<div style={{ whiteSpace: 'pre-wrap' }}>
				{ this.props.project.sales_description &&
					<div dangerouslySetInnerHTML={{__html: this.props.project.sales_description}}/>
				}

				<div style={{ marginTop: '40px', textAlign: 'center' }}>
					<div onClick={ () => this.props.parent.setState({ page: 'home' }) } className="button pink2-invert auto-width">Tillbaka</div>
				</div>
			</div>
		)
	}
}
export default About;



// WEBPACK FOOTER //
// ./src/components/user/Dashboard/About.js